import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import FinanciamentoCalculatorScreen from './screens/FinanciamentoCalculator/view';
import { AppStore, persist } from './store';

import './styles/global.css';

const isPublicCalculator =
  window.location.pathname === '/financeiro/calculadora' ||
  window.location.pathname === '/financeiro/calculadora/';

const application = isPublicCalculator ? (
  <BrowserRouter>
    <FinanciamentoCalculatorScreen />
  </BrowserRouter>
) : (
  <Provider store={AppStore}>
    <PersistGate loading={null} persistor={persist}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>{application}</StrictMode>,
);
